<script setup lang="ts">
import { onMounted, onBeforeUnmount, onUnmounted, ref, computed, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getOrderById, completeOrderById, saveProgressOrderById } from '@/composables/orderWorkerk';
import { setHaptic } from '@/tools/setTelegramHaptick';
import { createPopupManager } from '@/tools/setTelegramPopUp';
import { setBottomButton, hideBottomButton, setBackButton, hideBackButton, setBottomSecondaryButton, hideBottomSecondaryButton } from '@/tools/setTelegramButtons';
import router from '@/router';
import Point from '@/models/point';
import { OrderForScan, Item } from '@/models/order_scan_models/orderScan';
import OrderItem from '@/components/mobile/telegram/order_collect/OrderItem.vue'
import AnimatePlaceHolder from '@/components/mobile/telegram/AnimatePlaceHolder.vue';
import { formatedDateDay } from '@/tools/tools'

const popupManager = createPopupManager();

const store = useStore();
const context = ref<string>('');
const points = ref<Point[]>(store.getters.getAllPoints);
const pointId = ref<number>();
const orderId = ref<Number | null>(null)
const order = ref<OrderForScan>();
const isClosingBecCompleated = ref<boolean>(false);
const isOpenModalItem = ref<{ isOpened: boolean, item: Item | null }>({isOpened: false, item: null});
const inputQuery = ref<string>('');
const isOpenedInput = ref<boolean>(false);
const inputRef = ref<HTMLInputElement | null>(null);
const respIsResieved = ref<boolean>(false);

const currentPoint = computed(() => {
  return points.value.find((point: Point) => point.id === pointId.value) ?? null
})

const allItemsScanned = computed(() => {
  return order.value?.items.some(item => item.scannedQuantity >= 1);
})

const getTargetItem = (id?: number) => {
  return order.value?.items.find(item => item.idx === id)
}


onMounted(async () =>{
  setBackButton();
  let point_id = Number(useRoute().query.point_id);
  let order_id = Number(useRoute().query.order_id);
  orderId.value = order_id;
  context.value = String(useRoute().query.context);
  pointId.value = point_id;
  hideBottomButton();
  await getMyOrderById(point_id, order_id, store.getters.USER.role, context.value);
})

async function getMyOrderById(point_id: number | null, order_id: number, role: string, context: string) {
  order.value = await getOrderById(point_id, order_id, role, context);
  order.value?.items.map((item, index) => {item.idx = index})
  nextTick(() => {
    if (allItemsScanned.value === true) {
      setBottomButton('Завершить', '31B545', 'FFFFFF', completeOrder);
    }
  })
  respIsResieved.value = true;
  console.log('order.value=', order.value)
}

function handleSecondaryButton() {
  if(isOpenedInput.value === false) {
    isOpenedInput.value = true;
    setBottomButton('Подтвердить', '31B545', 'FFFFFF', mainButtonPressed);
    hideBottomSecondaryButton();
    nextTick(() => {
      if (inputRef.value) {
        inputRef.value.focus();
        if (isOpenModalItem.value.item?.scannedQuantity !== 0) {
          inputQuery.value = String(isOpenModalItem.value.item?.scannedQuantity)
        }
      }
    })
  } else {
    isOpenedInput.value = false;
    setBottomSecondaryButton('Ввести кол-во вручную', 'F8A917', 'FFFFFF', 'top', handleSecondaryButton);
    if (isOpenModalItem.value.item!.scannedQuantity < isOpenModalItem.value.item!.orderQuantity) {
      setBottomButton('Добавить весь товар', '31B545', 'FFFFFF', mainButtonPressed);
    } else {
      hideBottomButton();
    }
  }
}

function closeInputItem() {
  isOpenedInput.value = false;
}

function mainButtonPressed() {
  if (isOpenModalItem.value.isOpened === true && isOpenModalItem.value.item && isOpenedInput.value === false) {
    const targetItem = getTargetItem(isOpenModalItem.value.item?.idx)
    if (targetItem) {
      targetItem.scannedQuantity = targetItem.orderQuantity;
      isOpenModalItem.value.isOpened = false;
    }
    if (allItemsScanned.value === true) {
      isOpenModalItem.value.item = null;
      hideBottomSecondaryButton();
      setBottomButton('Завершить', '31B545', 'FFFFFF', completeOrder);
    }
  }
  if (isOpenedInput.value === true) {
    isOpenedInput.value = false;
    inputQuery.value = ''; 
    setBottomSecondaryButton('Ввести кол-во вручную', 'F8A917', 'FFFFFF', 'top', handleSecondaryButton);
    if (isOpenModalItem.value.item!.scannedQuantity < isOpenModalItem.value.item!.orderQuantity) {
      setBottomButton('Добавить весь товар', '31B545', 'FFFFFF', mainButtonPressed);
    } else {
      hideBottomButton();
    }
  }
}

onBeforeUnmount(async() => {
  if (isClosingBecCompleated.value === false) {
    const data = await saveProgressOrderById(pointId.value!, order.value!.order_id, context.value, order.value!.items)
    if (data) {
      popupManager.openPopup(`Прогресс по заказу №${order.value?.order_id} сохранён`,() => {});
    }
  }
})

function noneClick() {
  console.log('click')
}

async function completeOrder() {
  setBottomButton('Ждём подтверждения', '31B545', 'FFFFFF', null, false, true);
  const data = await completeOrderById(order.value!.order_id, context.value, order.value!.items);
  if (data) {
    popupManager.openPopup(`Статус заказа изменён на ${data.status}`,(buttonId) => {
      if (buttonId === 'cancel') {
        if (router.currentRoute.value.meta?.allowBack !== false && window.history.length > 1) {
          router.go(-1);
        } else {
          router.push('/');
        }
      }
    });
  }
}

onUnmounted(() => {
  hideBottomButton();
  hideBackButton();
})

function selectItem(id?: number) {
  setHaptic();
  isOpenModalItem.value.isOpened = !isOpenModalItem.value.isOpened;
  if (isOpenedInput) {
    closeInputItem();
  }
  if (id !== undefined) {
    const targetItem = getTargetItem(id);
    if (targetItem) isOpenModalItem.value.item = targetItem;
    setBottomSecondaryButton('Ввести кол-во вручную', 'F8A917', 'FFFFFF', 'top', handleSecondaryButton);
    if (isOpenModalItem.value.item!.scannedQuantity < isOpenModalItem.value.item!.orderQuantity) {
      setBottomButton('Добавить весь товар', '31B545', 'FFFFFF', mainButtonPressed);
    } else {
      hideBottomButton();
    }
  } else {
    isOpenModalItem.value.item = null;
    hideBottomButton();
    hideBottomSecondaryButton();
    if (allItemsScanned.value === true) {
      setBottomButton('Завершить', '31B545', 'FFFFFF', completeOrder);
    }
  }
  if (isOpenModalItem.value.isOpened === false) {
    isOpenModalItem.value.item = null;
  }
}

watch(() => inputQuery.value, (newVal) => {
  const targetItem = getTargetItem(isOpenModalItem.value.item?.idx)
  if (targetItem && isOpenedInput.value === true) {
    targetItem.scannedQuantity = Number(newVal);
  }
}, { immediate: true });

</script>

<template>

  <Transition name="fade">
    <div class="background-blur-select-item" v-if="isOpenModalItem.isOpened" @click="selectItem()"></div>
  </Transition>

  <div class="order-wrapper">
    <div class="order-header">
      <div class="absolute-status" :style="{ backgroundColor: order?.status == 'Доставлен' ? 'var(--green-color)' : 'var(--orange-color)' }"></div>
      <p class="name-point">{{ currentPoint?.name }}</p>
      <p class="name-order">Заказ #{{ orderId }}</p>
      <p class="name-order">Создан: {{ formatedDateDay(order?.date_create) }}</p>
      <p class="order-status" :style="{ color: order?.status === 'Доставлен' ? 'var(--green-color)' : 'var(--orange-color)' }">{{ respIsResieved ? order?.status : '----' }}</p>
      <p v-if="order?.comment && respIsResieved" class="comment">{{ order?.comment}}</p>
    </div>

    <TransitionGroup 
      name="buttons-transition" 
      tag="div"
      class="order-items"
      v-if="respIsResieved"
    >
    <OrderItem v-for="(item, id) in order?.items"
      @click="selectItem(item.idx)"
      :item="item"
      :key="id"
      :class="{ 'is-open': isOpenModalItem.item?.idx === item.idx }"
    />
    </TransitionGroup>
    <AnimatePlaceHolder v-else-if="!respIsResieved"
      width="100%"
      height="295px"
      border-radius="var(--border-radius)"
      style="margin-top: 5px;"
    />

  </div>
  
  <Transition name="fade">
    <div class="background-blur-enter-input" v-if="isOpenedInput" @click="closeInputItem()"></div>
  </Transition>

  <Transition name="slideUp">
    <div class="input-iteminorder" v-if="isOpenedInput">
      <input v-model="inputQuery"
        ref="inputRef"
        class="search"
        id="msg"
        type="number"
        inputmode="numeric"
        placeholder="Введите количество..."
      />
    </div>
  </Transition>

</template>

<style scoped>

input.search::placeholder {
  color: #B9B9B9;
}

input.search {
  background-color: inherit;
  font-size: 20px;
  padding: 0px;
  font-family: inherit;
  margin: 0;
  border: none;
  outline: none;
  width: 100%;
  margin-left: 5px;
}

.input-iteminorder {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: var(--grey-color);
  padding: 20px;
  box-sizing: border-box;
  z-index: 4;
}

.is-open {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  width: 98%;
}

.buttons-transition-move,
.buttons-transition-enter-active,
.buttons-transition-leave-active {
  transition: all 0.3s ease-in-out;
}

.background-blur-select-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 3;
  background-color: #8E8E9290;
  backdrop-filter: blur(10px);
}

.background-blur-enter-input {
  z-index: 5;
  position: fixed;
}

.order-items{
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 2%;
  gap: 5px;
}

.comment {
  font-size: 13px;
  width: 100%;
  text-align: start;
  color: #525252;
  padding: 10px 20px;
  background-color: var(--grey-color);
  border-radius: var(--border-radius-2);
  box-sizing: border-box;
  margin-top: 5px;
}

.order-status {
  font-size: 15px;
  color: var(--green-color);
  font-weight: 600;
}

.name-order{
  font-size: 18px;
  color: black;
  font-weight: 600;
}

.name-point {
  font-size: 16px;
  color: #B9B9B9;
  font-weight: 600;
}

.absolute-status {
  position: absolute;
  width: 5px;
  height: 100%;
  top: 0;
  left: 0;
}

.order-header{
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 5px;
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: var(--border-radius);
  box-shadow: var(--drop-shadow-item);
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1;
  overflow: hidden;
}

.order-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

</style>